/*
 * @Description: 图片验证工具
 * @Date: 2026-05-12
 * @FilePath: \hui_ai_ui\src\utils\imageHelper.js
 */

export const VALID_IMAGE_EXTENSIONS = ['.jpg', '.jpeg', '.png', '.gif'];

export function validateImageByMagicNumber(file) {
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      const arr = new Uint8Array(e.target.result);
      if (arr[0] === 0xFF && arr[1] === 0xD8 && arr[2] === 0xFF) {
        resolve(true);
      } else if (arr[0] === 0x89 && arr[1] === 0x50 && arr[2] === 0x4E && arr[3] === 0x47) {
        resolve(true);
      } else if (arr[0] === 0x47 && arr[1] === 0x49 && arr[2] === 0x46 && arr[3] === 0x38) {
        resolve(true);
      } else if (arr[0] === 0x52 && arr[1] === 0x49 && arr[2] === 0x46 && arr[3] === 0x46 &&
        arr[8] === 0x57 && arr[9] === 0x45 && arr[10] === 0x42 && arr[11] === 0x50) {
        resolve(true);
      } else if (arr[0] === 0x42 && arr[1] === 0x4D) {
        resolve(true);
      } else if (arr[0] === 0x3C && arr[1] === 0x3F && arr[2] === 0x78 && arr[3] === 0x6D && arr[4] === 0x6C) {
        resolve(true);
      } else {
        resolve(false);
      }
    };
    reader.readAsArrayBuffer(file.slice(0, 12));
  });
}

export async function validateImage(file, validExtensions = VALID_IMAGE_EXTENSIONS) {
  const rawFile = file.raw || file;
  const fileName = rawFile.name.toLowerCase();
  const hasValidExtension = validExtensions.some(ext => fileName.endsWith(ext));
  const isImageMimeType = rawFile.type && rawFile.type.startsWith('image/');
  const isValidImage = await validateImageByMagicNumber(rawFile);
  return hasValidExtension && isImageMimeType && isValidImage;
}